module.exports = __webpack_public_path__ + "img/header-diamondJewelry050Carat@2x.a213b61.jpg";